import { useAppDispatch } from 'src/store'
import { squareCharge, SquareChargeParams } from 'src/useCase/payment'

export type FormValues = {
  source_id: string
  plan_type: string
}
export const usePayment = () => {
  const dispatch = useAppDispatch()

  const onCharge = async (tokenResult, planType, orderParams) => {
    const {
      status,
      token,
      verification_token,
      building_name,
      address,
      city,
      state,
      postalCode,
    } = tokenResult
    if (status === 'OK') {
      const chargeParams: SquareChargeParams = {
        source_id: token,
        plan_type: planType,
        verification_token,
        building_name: building_name,
        prefecture_id: state,
        address: address,
        city_id: city,
        postal_number: postalCode,
        is_deferred_payment: true,
      }
      await dispatch(
        squareCharge({
          orderParams,
          chargeParams,
        }),
      )
    }
  }

  return {
    onCharge,
  }
}
